import styled from "styled-components";
import { isWeiBo, isWeiXin } from "../base/util";
const Index = ({
    image_url,
    title,
    price,
    date,
    link,
    special_content,
    tao_token,
    showToken
}) =>{
    return (
        <Container onClick={()=>{
            if(isWeiBo()){
                let iframe = document.createElement("iframe");
                iframe.style.visibility = "hidden";
                iframe.style.width = 0;
                iframe.style.height = 0;
                iframe.src = link;
                document.body.appendChild(iframe);
                return;
            }
            if(isWeiXin() && showToken){
                showToken(tao_token);
                return;
            }
            window.location.href = link;
        }}>
            <Img src={image_url} loading='lazy'/>
            <Info>
                <Top>
                    <Title>
                        {title}
                    </Title>
                    {special_content && <Tip>
                        {special_content}
                    </Tip>}
                    <Price>
                        直播价格：¥{price}
                    </Price>
                </Top>
                <Bottom>
                    <Time><TimeText>直播时间: {date}</TimeText></Time>
                    <View>查看商品</View>
                </Bottom>
            </Info>
            
        </Container>
    )
}

export default Index;

const Container = styled.div`
    display: flex;
    flex-direction: row;
`;

const Img = styled.img`
    width: 120px;
    height: 120px;
`;

const Info = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 15px;
`;

const Top = styled.div`
    display: flex;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 15px;
`;
const Tip = styled.div`
    margin-top: 5px;
    color: #7e7e7e;
    font-size: 14px;
`;

const Price = styled.div`
    margin-top: 6px;
    color: #f76d0f;
    font-size: 13px;
`;

const Bottom = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const Time = styled.div`
    border: 1px solid #7e7e7e;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const TimeText = styled.div`
    color: #7e7e7e;
    font-size: 12px;
    margin: 0px 10px;
`;
const View = styled.div`
    border: 1px solid #f76d0f;
    border-radius: 5px;
    padding: 5px;
    font-size: 12px;
    color: #f76d0f;
`;